import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3863872"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","flex-direction":"column","padding":"0"} }
const _hoisted_2 = { style: {"flex":"1","height":"100%","overflow-y":"auto"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"16px","background":"#f2f4f8"} }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"16px","background":"#f2f4f8"} }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"16px","background":"#f2f4f8"} }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"16px","background":"#f2f4f8"} }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"16px","background":"#f2f4f8"} }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"16px","background":"#f2f4f8"} }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"16px","background":"#f2f4f8"} }, null, -1))
const _hoisted_10 = { class: "affix-box" }

import { onBeforeMount, ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {
  BaseButton,
  useCreateModal,
  XrkMessage,
  XrkMessageBox
} from 'xrk-components';
import {
  DetailOperator,
  DetailBank,
  DetailMaterial,
  DetailValidity,
  DetailPlatform,
  DetailPark,
  DetailTerminateDialog,
  DetailLicense
} from '../components/detail';
import {
  individualInfoDetail,
  platformAudit,
  parkAudit,
  modifyIndividual
} from '../data-source/apis';
import { IndividualInfoDetailData } from '../data-source/types';
import { DetailRouteQuery } from '../types';
import { ENTER_TYPE } from '../constants';


export default /*#__PURE__*/_defineComponent({
  ...{
  name: 'individual-household-detail'
},
  __name: 'detail',
  setup(__props) {

const AUDIT_AJAX: {
  [key in DetailRouteQuery['enterType']]: any;
} = {
  platformAudit: platformAudit,
  parkAudit: parkAudit,
  detail: null
};



const router = useRouter();
const query = useRoute().query as DetailRouteQuery;
const auditAjax = AUDIT_AJAX[query.enterType];

const detailLicenseRef = ref();
const detailValidityRef = ref();
const detailPlatformRef = ref();
const formData = ref<IndividualInfoDetailData>({
  individualName: '',
  businessParkName: '',
  idcard: '',
  cardId: '',
  operator: '',
  phone: '',
  entpCertType: null,
  entpCertNo: '',
  entpCertPic: '',
  expiraStart: '',
  expiraEnd: '',
  enable: null,
  bankInfo: '',
  bankCardNum: '',
  registerAt: '',
  declareMethod: null,
  taxAssessmentMethod: null,
  invoiceType: null,
  invoiceItemIdList: [],
  historyExpiraDateList: [],
  cardIdFront: '',
  cardIdBack: '',
  additionalRemark: '',
  intentNameList: [],
  fileList: [],
  individualType: 3, // 只能添加园区个体户
  auditStatus: null,
  auditTerminationReason: '',
  auditTerminationRemark: '',
  id: null,
  createBy: '',
  updateBy: '',
  createAt: '',
  updateAt: '',
  deleted: null,
  _expira: [],
  _fileList: [],
  _invoiceType: [],
  businessParkId: 0,
  isSkipFile: 0,
  isPermanent: 0,
  businessScope: '',
  businessAddress: ''
});

const isGt2AuditStatus11 = computed(() => {
  return formData.value.auditStatus == 11 && formData.value.individualType == 2;
});
/*
  是否展示平台审核内容
    园区个体(3)审核中(11)不展示，其他都展示，无操作，有信息
    客户个体(2)审核中(11)展示，有操作，无信息
*/
const showPlatform = computed(() => {
  return isGt2AuditStatus11.value || formData.value.auditStatus != 11;
});

const initValidity = async () => {
  const { data } = await individualInfoDetail({
    businessIndividualId: +query.id
  });
  Object.assign(formData.value, {
    _expira: [data.expiraStart, data.expiraEnd],
    expiraStart: data.expiraStart,
    expiraEnd: data.expiraEnd,
    historyExpiraDateList: data.historyExpiraDateList
  });
};
const init = async () => {
  if (!query.id) {
    XrkMessage.error('参数错误');
    return;
  }
  if (!ENTER_TYPE.includes(query.enterType)) {
    XrkMessage.error('参数类型');
    router.go(-1);
    return;
  }
  const { data } = await individualInfoDetail({
    businessIndividualId: +query.id
  });
  formData.value = data;
};
const checkRefs = async () => {
  return Promise.all([
    detailLicenseRef.value.validate(),
    detailValidityRef.value.validate()
  ]);
};

// 终止
const onTerminate = () => {
  useCreateModal(DetailTerminateDialog, {
    id: query.id,
    auditAjax,
    onSuccess() {
      onCancel();
    }
  });
};
// 驳回
const onReject = async () => {
  const data = await XrkMessageBox.prompt('请输驳回原因', '提示', {
    cancelButtonText: '取消',
    confirmButtonText: '确认',
    inputType: 'textarea',
    inputErrorMessage: '请输入1-200个字符',
    inputValidator(v) {
      const _v = v.trim();
      return _v.length > 0 && _v.length <= 200;
    }
  });
  await auditAjax({
    id: +query.id,
    status: 3,
    auditTerminationReason: data.value
  });
  XrkMessage.success('操作成功');
  onCancel();
};
const onPass = async () => {
  // 园区校验字段
  if (query.enterType == 'parkAudit') {
    await checkRefs();
  }
  // 客户校验
  if (query.enterType == 'platformAudit' && isGt2AuditStatus11.value) {
    await detailPlatformRef.value.validate();
  }
  XrkMessageBox.confirm('是否确认通过？', '提示', {
    cancelButtonText: '取消',
    confirmButtonText: '确认'
  }).then(async () => {
    await auditAjax({
      ...formData.value,
      id: +query.id,
      status: 2
    });
    XrkMessage.success('操作成功');
    onCancel();
  });
};
const onSave = async () => {
  await checkRefs();
  await modifyIndividual(formData.value);
  XrkMessage.success('保存成功');
  onCancel();
};
const onCancel = () => {
  router.go(-1);
};

onBeforeMount(async () => {
  init();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DetailOperator), {
        modelValue: formData.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData).value = $event))
      }, null, 8, ["modelValue"]),
      _hoisted_3,
      _createVNode(_unref(DetailBank), {
        modelValue: formData.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData).value = $event))
      }, null, 8, ["modelValue"]),
      _hoisted_4,
      _createVNode(_unref(DetailMaterial), {
        modelValue: formData.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData).value = $event))
      }, null, 8, ["modelValue"]),
      _hoisted_5,
      (_unref(query).enterType !== 'platformAudit')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_unref(DetailLicense), {
              ref_key: "detailLicenseRef",
              ref: detailLicenseRef,
              modelValue: formData.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData).value = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_6,
            _createVNode(_unref(DetailValidity), {
              ref_key: "detailValidityRef",
              ref: detailValidityRef,
              modelValue: formData.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData).value = $event)),
              onSuccess: initValidity
            }, null, 8, ["modelValue"]),
            _hoisted_7
          ], 64))
        : _createCommentVNode("", true),
      (showPlatform.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_unref(DetailPlatform), {
              ref_key: "detailPlatformRef",
              ref: detailPlatformRef,
              modelValue: formData.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData).value = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_8
          ], 64))
        : _createCommentVNode("", true),
      (formData.value.auditStatus >= 21)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(_unref(DetailPark), {
              modelValue: formData.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData).value = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_9
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_unref(query).enterType !== 'detail')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            ([21].includes(+formData.value.auditStatus))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_unref(BaseButton), {
                    type: "default",
                    onClick: onCancel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("取消")
                    ]),
                    _: 1
                  }),
                  (formData.value.individualType == 3)
                    ? (_openBlock(), _createBlock(_unref(BaseButton), {
                        key: 0,
                        type: "danger",
                        onClick: onTerminate
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 终止 ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(BaseButton), {
                    type: "danger",
                    onClick: onReject
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("驳回")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(BaseButton), {
                    type: "primary",
                    onClick: onPass
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(formData.value.individualType == 2 ? '提交' : '通过'), 1)
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_unref(BaseButton), {
              type: "default",
              onClick: onCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            ([22].includes(+formData.value.auditStatus))
              ? (_openBlock(), _createBlock(_unref(BaseButton), {
                  key: 0,
                  type: "primary",
                  onClick: onSave
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 保存 ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 64))
    ])
  ]))
}
}

})